import { render } from "./addSwiper.vue?vue&type=template&id=eeb08ab6&scoped=true"
import script from "./addSwiper.vue?vue&type=script&lang=js"
export * from "./addSwiper.vue?vue&type=script&lang=js"

import "./addSwiper.vue?vue&type=style&index=0&id=eeb08ab6&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb08ab6"]])

export default __exports__